module.exports = __webpack_public_path__ + "static/media/blog1.4c108374.jpg";